(function () {
  var config = window.freeGiftConfig;
  if (!config || !config.variantId || !config.threshold) return;

  var busy = false;
  var pending = false;

  function isEligible(item) {
    if (item.variant_id === config.variantId) return false;
    if (!config.eligibleProductIds.length) return true;
    return config.eligibleProductIds.indexOf(item.product_id) !== -1;
  }

  function eligibleTotal(cart) {
    return cart.items.reduce(function (total, item) {
      return isEligible(item) ? total + item.final_line_price : total;
    }, 0);
  }

  function findGift(cart) {
    return cart.items.find(function (item) {
      return item.variant_id === config.variantId;
    });
  }

  function formatPrice(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }).replace('.00', '');
  }

  // Keeps the add-to-cart notification popup in sync with the promotion:
  // shows a nudge below the threshold and a confirmation once the gift is in.
  function updateNotification(cart) {
    var element = document.getElementById('cart-notification-free-gift');
    if (!element) return;
    var gift = findGift(cart);
    var total = eligibleTotal(cart);
    if (gift && gift.final_price === 0) {
      element.textContent = '🎁 Free ' + (config.title || 'gift') + ' added to your cart!';
      element.classList.remove('hidden');
    } else if (!gift && total > 0 && total < config.threshold) {
      element.textContent =
        'Add ' + formatPrice(config.threshold - total) + ' more to get a free ' + (config.title || 'gift') + '!';
      element.classList.remove('hidden');
    } else {
      element.classList.add('hidden');
    }
  }

  // Re-render the drawer / cart page through the existing cart-items
  // subscribers, and refresh the header icon bubble ourselves since no
  // subscriber owns it outside a user-initiated quantity change.
  function refreshCartUI(cart) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift', cartData: cart });
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch('/cart?section_id=cart-icon-bubble')
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var section = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      })
      .catch(function () {});
  }

  function afterMutation(response) {
    if (!response.ok) return;
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateNotification(cart);
        refreshCartUI(cart);
      });
  }

  function syncFreeGift() {
    if (busy) {
      pending = true;
      return;
    }
    busy = true;
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var gift = findGift(cart);
        var total = eligibleTotal(cart);

        if (total >= config.threshold && !gift) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: config.variantId, quantity: 1 }),
          }).then(afterMutation);
        }

        // Only ever auto-remove (or clamp) a gift line the discount actually
        // zeroed out — never touch a line the customer is paying for.
        if (gift && gift.final_price === 0 && (total < config.threshold || gift.quantity > 1)) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: gift.key, quantity: total >= config.threshold ? 1 : 0 }),
          }).then(afterMutation);
        }

        updateNotification(cart);
      })
      .catch(function () {})
      .finally(function () {
        busy = false;
        if (pending) {
          pending = false;
          syncFreeGift();
        }
      });
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'free-gift') return;
        syncFreeGift();
      });
    }
    syncFreeGift();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
